import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const ru = {
  "Admin": "Админка",
  "Platform": "Платформа",
  "Partners": "Партнёры",
  "Finance": "Финансы",
  "Plans": "Тарифы",
  "Webhooks": "Webhooks",
  "Audit": "Аудит",
  "Settings": "Настройки",
  "Active partners": "Активные партнёры",
  "Active subs": "Активные подписки",
  "GMV today": "GMV сегодня",
  "Margin": "Маржа",
  "Pending withdraws": "Заявки на вывод",
  "Failed webhooks": "Сбойные webhooks",
  "All systems": "Все системы",
  "Online": "Online",
  "Search partners": "Поиск партнёров",
  "Active": "АКТИВЕН",
  "Banned": "ЗАБАНЕН",
  "Pending": "ОНБОРДИНГ",
  "Ban": "Заблокировать",
  "Unban": "Разблокировать",
  "Override markup": "Override наценки",
  "Partner finance": "Заработано / Выведено",
  "Approve": "Одобрить",
  "Decline": "Отклонить",
  "GMV": "GMV",
  "Platform margin": "Платформенная маржа",
  "Payment fees": "Комиссии платёжек",
  "Net": "Чистая",
  "Plan name": "Название",
  "Base price": "Базовая цена",
  "Floor": "Floor",
  "Visible": "Видим",
  "Webhook source": "Источник",
  "Webhook event": "Событие",
  "Webhook status": "Статус",
  "Webhook retry": "Повторить",
  "Audit who": "Кто",
  "Audit what": "Что",
  "Audit when": "Когда",
  "Rotation status": "Статус ротации секретов",
  "Save": "Сохранить",
  "Saved": "Сохранено",
  "Confirm ban": "Точно заблокировать?",
  "Cancel": "Отмена",
  "Tg user fallback": "Owner",
  "Top earners": "Топ-партнёры по выручке",
  "FX": "Курсы",
  "Broadcasts": "Рассылки",
  "Analytics": "Аналитика",
  "Markup cap": "Лимит наценки сверху, %",
  "Markup floor": "Лимит наценки снизу, %",
  "Reset": "Сбросить override",
  "Rate updated": "Курс обновлён",
  "Bulk refresh CBR": "Подтянуть CBR",
  "Audience all partners": "Все партнёры",
  "Audience all clients": "Все клиенты (через ботов партнёров)",
  "Cohort": "Когорта",
  "Signups": "Регистрации",
  "D7": "D7",
  "D30": "D30",
  "Retention": "Retention 30d",
  "Top geos": "Топ-страны",
};

const en = {
  "Admin": "Admin",
  "Platform": "Platform",
  "Partners": "Partners",
  "Finance": "Finance",
  "Plans": "Plans",
  "Webhooks": "Webhooks",
  "Audit": "Audit",
  "Settings": "Settings",
  "Active partners": "Active partners",
  "Active subs": "Active subs",
  "GMV today": "GMV today",
  "Margin": "Margin",
  "Pending withdraws": "Pending withdraws",
  "Failed webhooks": "Failed webhooks",
  "All systems": "All systems",
  "Online": "Online",
  "Search partners": "Search partners",
  "Active": "ACTIVE",
  "Banned": "BANNED",
  "Pending": "ONBOARDING",
  "Ban": "Ban",
  "Unban": "Unban",
  "Override markup": "Override markup",
  "Partner finance": "Earned / Withdrawn",
  "Approve": "Approve",
  "Decline": "Decline",
  "GMV": "GMV",
  "Platform margin": "Platform margin",
  "Payment fees": "Payment fees",
  "Net": "Net",
  "Plan name": "Name",
  "Base price": "Base price",
  "Floor": "Floor",
  "Visible": "Visible",
  "Webhook source": "Source",
  "Webhook event": "Event",
  "Webhook status": "Status",
  "Webhook retry": "Retry",
  "Audit who": "Who",
  "Audit what": "What",
  "Audit when": "When",
  "Rotation status": "Secret rotation status",
  "Save": "Save",
  "Saved": "Saved",
  "Confirm ban": "Really ban?",
  "Cancel": "Cancel",
  "Tg user fallback": "Owner",
  "Top earners": "Top earning partners",
  "FX": "FX rates",
  "Broadcasts": "Broadcasts",
  "Analytics": "Analytics",
  "Markup cap": "Markup cap, %",
  "Markup floor": "Markup floor, %",
  "Reset": "Reset override",
  "Rate updated": "Rate updated",
  "Bulk refresh CBR": "Refresh from CBR",
  "Audience all partners": "All partners",
  "Audience all clients": "All clients (via partner bots)",
  "Cohort": "Cohort",
  "Signups": "Signups",
  "D7": "D7",
  "D30": "D30",
  "Retention": "Retention 30d",
  "Top geos": "Top countries",
};

i18n.use(initReactI18next).init({
  resources: { ru: { translation: ru }, en: { translation: en } },
  lng: 'ru',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
